import React, { useContext } from 'react';
import Toast from 'react-bootstrap/Toast';
import { DataContext } from '../../../stores/crm-store';
import { useTranslation } from 'react-i18next';
import { DELETED, ERROR, SAVED } from '../../../i18n/keyConstants';

const ExlToasts = () => {
    const { t } = useTranslation(['shared']);
    const {
        store: { isGenericExlErrorToastOpen, genericExlErrorToastMsg, isSavedToastOpen, isDeletedToastOpen, isErrorToastOpen },
        dispatch,
    } = useContext(DataContext);

    const onToastClose = (type) => {
        dispatch({ type });
    };

    return (
        <div>
            <div className='exl-toasts'>
                <div className='generic-exl-error-toast'>
                    <CustomToast
                        className='bg-danger'
                        icon='oi-x'
                        content={genericExlErrorToastMsg}
                        isOpen={isGenericExlErrorToastOpen}
                        onClose={() => onToastClose('CLOSE_GENERIC_EXL_ERROR_TOAST')}
                        delay={5 * 1000}
                    />
                </div>
            </div>

            <div className='toasts'>
                <CustomToast
                    className='bg-success'
                    icon='oi-check'
                    content={t(SAVED)}
                    isOpen={isSavedToastOpen}
                    onClose={() => onToastClose('CLOSE_SAVED_TOAST')}
                />
                <CustomToast
                    className='bg-info'
                    icon='oi-check'
                    content={t(DELETED)}
                    isOpen={isDeletedToastOpen}
                    onClose={() => onToastClose('CLOSE_DELETED_TOAST')}
                />
                <CustomToast
                    className='bg-danger'
                    icon='oi-x'
                    content={t(ERROR)}
                    isOpen={isErrorToastOpen}
                    onClose={() => onToastClose('CLOSE_ERROR_TOAST')}
                />
            </div>
        </div>
    );
};

export default ExlToasts;

const CustomToast = ({ className, icon, content, isOpen, onClose, delay }) => {
    if (delay == null) {
        delay = 2 * 1000;
    }
    return (
        <Toast className={className} onClose={onClose} show={isOpen} delay={delay} autohide animation>
            <Toast.Body>
                <div className={'oi ' + icon} />
                <div>{content}</div>
            </Toast.Body>
        </Toast>
    );
};
